import {
  FETCH_NODE_LIST_FAILURE,
  FETCH_NODE_LIST_REQUEST,
  FETCH_NODE_LIST_SUCCESS,
  FETCH_NODE_LIST_UPDATE,
} from "../types/fetchNodeListType";

interface StoreClusterNodeInitialState {
  data: [];
  error: string;
}

const initialState: StoreClusterNodeInitialState = {
  data: [],
  error: "",
};

export function storeClusterNodeReducer(state = initialState, action: any) {
  switch (action.type) {
    case FETCH_NODE_LIST_REQUEST:
      return {
        ...state,
        data: [],
        error: "",
      };
    case FETCH_NODE_LIST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        error: "",
      };
    case FETCH_NODE_LIST_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
      case FETCH_NODE_LIST_UPDATE:
        return{
          ...state,
          data:[...state.data , ...action.payload],
          error: "",
        }
    default:
      return state;
  }
}
